import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PostLoginAuthGuard implements CanActivate {
  constructor(public authService: AuthService, public router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url === '/auth/second-factor') {
      const isUserTokenAvailable = this.authService.isUserTokenAvailable();
      if (!isUserTokenAvailable) {
        this.router.navigate(['/auth/login']);
        return false;
      }
      return true;
    } else {
      return this.authService.loggedIn.pipe(
        first(),
        map(result => {
          if (!result) {
            this.authService.setRedirectionUrl();
            this.router.navigate(['/auth/login']);
            return false;
          }
          return true;
        }),
      );
    }
  }
}
